<template>
  <div :class="['col-xs-12', `col-md-${size}`]">
    <form-group-search-select
      ref="input"
      :label="label"
      :readonly="readonly"
      :name="name"
      :options="cursos || []"
      :data-vv-as="label"
      :placeholder="localPlaceholder"
      :value="value"
      @input="atualizarCurso($event)"
      @change="atualizarCurso($event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
import AlunoService from "../../../../domain/corpore/AlunoService";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
  name: "c-protocolo-curso",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    size: {
      type: String,
      default: "6"
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean,
    login: {
      type: String,
      default: ""
    },
    servicoId: String
  },
  data() {
    return {
      localPlaceholder: this.placeholder
    };
  },
  computed: {
    usuario() {
      return this.$store.state.usuario;
    }
  },
  asyncComputed: {
    cursos() {
      const alunoService = new AlunoService(this.$http);
      let login = this.login !== "" ? this.login : this.usuario.login;
      // Variável de controle para a filtragem da modalidade (true se for 169)
      const isSolicitacaoDP = this.servicoId === "169";

      if (login) {
        return alunoService
          .getCursosAlunoByRa(login, true)
          .then(result => {
            // 1. Aplica a filtragem condicional de apenas EADs para solicitação de DP
            let cursosFiltrados = result;
            if (isSolicitacaoDP) {
              cursosFiltrados = result.filter(curso => curso.modalidade === 2);
            }

            if (cursosFiltrados.length <= 0 && this.servicoId === "169") {
              this.localPlaceholder = "Não conseguimos achar um curso ativo para buscar as DP";
            }

            // 2. Mapeia os resultados (filtrados ou não)
            return cursosFiltrados.map(curso => ({
              value: curso.CODCURSO,
              text: `${curso.NOME}${
                curso.modNome ? " - " + curso.modNome : ""
              }`,
              codPerlet: curso.CODPERLET,
              periodo: curso.PERIODO
            }));
          })
          .catch(err => {
            SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
          });
      }
    },
    setCurso() {
      if (this.cursos && this.cursos.length === 1) {
        this.$validator.reset();
        this.atualizarCurso(this.cursos[0].value.toString());
      }
    }
  },
  methods: {
    atualizarCurso(value) {
      if (value != null) {
        this.formValues.cursoId = value;
        this.$el.value = value;
        this.$emit("input", value);
      }
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/Curso.vue